import React from "react";

export default function NavSideLinks({ links }) {
  return (
    <ul className={"flex"}>
      {links.map(({ route, label }, i) => (
        <li key={i}>
          <a href={route}>{label}</a>
        </li>
      ))}
    </ul>
  );
}
